import React, { ComponentPropsWithoutRef, ReactElement, useId } from "react";
import styles from "./InputWrapperWithErrorMessage.module.less";
import Translated from "../infrastructure/translation/Translated";
import { TranslationKey } from "../infrastructure/translation/translator";

interface InputErrorWrapperProps {
  errorTextKey: TranslationKey;
  InputComponent: ReactElement<ComponentPropsWithoutRef<"input">>;
  showError: boolean;
  customClassName?: string;
}

export function InputWrapperWithErrorMessage({
  errorTextKey,
  InputComponent,
  showError,
  customClassName,
}: InputErrorWrapperProps) {
  const errorMessageId = "error_" + useId();

  const inputWithAria = React.cloneElement(InputComponent, {
    "aria-invalid": showError,
    "aria-errormessage": showError ? errorMessageId : undefined,
  });

  const wrapperClassName = `${showError ? styles.hasError : styles.noError} ${customClassName || ""}`;

  return (
    <div className={wrapperClassName}>
      {inputWithAria}
      <span
        id={errorMessageId}
        className={showError ? styles.errorMessage : styles.hidden}
      >
        <Translated textKey={errorTextKey} />
      </span>
    </div>
  );
}
